/* Lens Color dropdown: (i) button → tooltip with a short lens description.
   Text comes from the lens_type metaobject via data-lens-tip (main-product.liquid).
   The list scrolls (overflow-y:auto), so the tooltip is one fixed-position element
   on <body> instead of a child of the row — otherwise the list would clip it. */
(function () {
  var pop, cur;
  var hoverable = window.matchMedia('(hover: hover)').matches;

  function ensure() {
    if (pop) return pop;
    pop = document.createElement('div');
    pop.className = 'hgLensTipPop';
    pop.id = 'hgLensTipPop';
    pop.setAttribute('role', 'tooltip');
    pop.hidden = true;
    document.body.appendChild(pop);
    return pop;
  }

  function show(btn) {
    var p = ensure();
    if (cur && cur !== btn) cur.setAttribute('aria-expanded', 'false');
    cur = btn;
    p.textContent = btn.getAttribute('data-lens-tip') || '';
    p.hidden = false;
    btn.setAttribute('aria-describedby', p.id);
    btn.setAttribute('aria-expanded', 'true');
    var r = btn.getBoundingClientRect(), pw = p.offsetWidth, ph = p.offsetHeight, m = 8;
    var left = Math.min(Math.max(m, r.right - pw), window.innerWidth - pw - m);
    var top = r.top - ph - m;
    if (top < m) top = r.bottom + m;
    p.style.left = left + 'px';
    p.style.top = top + 'px';
  }

  function hide() {
    if (!pop || pop.hidden) return;
    pop.hidden = true;
    if (cur) { cur.setAttribute('aria-expanded', 'false'); cur.removeAttribute('aria-describedby'); }
    cur = null;
  }

  function btnOf(node) { return node && node.closest ? node.closest('.hgLensInfo') : null; }

  /* Capture phase: the row's own click handler selects the variant and the
     document handler closes the dropdown — the (i) must do neither. */
  document.addEventListener('click', function (e) {
    var b = btnOf(e.target);
    if (!b) { hide(); return; }
    e.stopPropagation();
    e.preventDefault();
    if (!hoverable && cur === b && !pop.hidden) hide(); else show(b);
  }, true);

  if (hoverable) {
    document.addEventListener('mouseover', function (e) { var b = btnOf(e.target); if (b) show(b); });
    document.addEventListener('mouseout', function (e) {
      var b = btnOf(e.target);
      if (b && !b.contains(e.relatedTarget)) hide();
    });
  }
  /* Keyboard focus only: a tap also focuses the button, and the click right after
     would toggle the tooltip straight back off. */
  document.addEventListener('focusin', function (e) {
    var b = btnOf(e.target);
    if (b && b.matches(':focus-visible')) show(b);
  });
  document.addEventListener('focusout', function (e) { if (btnOf(e.target)) hide(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') hide(); });
  document.addEventListener('scroll', hide, true);
  window.addEventListener('resize', hide);

  /* Trigger (i) (shown when only one lens is in stock): hg-product-swatches.js
     re-selects rows when another option changes, so mirror the selected row's tip. */
  function syncTrigger(swatch) {
    var t = swatch.querySelector('.hgLensInfoTrigger');
    if (!t) return;
    var s = swatch.querySelector('.variantSwatchItemSelected .hgLensInfo');
    t.hidden = !s;
    if (s) {
      t.setAttribute('data-lens-tip', s.getAttribute('data-lens-tip'));
      t.setAttribute('aria-label', s.getAttribute('aria-label'));
    }
  }
  function initTriggers() {
    document.querySelectorAll('.variantSwatch').forEach(function (sw) {
      if (!sw.querySelector('.hgLensInfoTrigger')) return;
      syncTrigger(sw);
      new MutationObserver(function () { syncTrigger(sw); })
        .observe(sw, { subtree: true, attributes: true, attributeFilter: ['class'] });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTriggers);
  else initTriggers();
})();

/* Lens Guide lightbox: click a lens image → large view; arrows / swipe / keys page
   through every image in the guide, caption under the image shows that lens's
   short description. Data comes from the .hgLensGuideZoom buttons' data-* attrs. */
(function () {
  var box, img, title, vlt, desc, count, list = [], idx = 0, lastFocus;

  function build() {
    box = document.createElement('dialog');
    box.className = 'hgLensBox';
    box.setAttribute('aria-label', 'Lens images');
    // Кнопки — те же классы и иконки, что у окна основного фото (imageModalClose/imageModalNav в styles.css)
    box.innerHTML =
      '<button type="button" class="hgLensBoxClose imageModalClose" aria-label="Close"><svg class="icon icon-close-circle" viewBox="0 0 44 44" fill="none" aria-hidden="true" focusable="false"><use href="#icon-close-circle"/></svg></button>' +
      '<figure class="hgLensBoxFig">' +
        '<div class="hgLensBoxStage">' +
          '<button type="button" class="hgLensBoxNav hgLensBoxPrev imageModalNav" aria-label="Previous lens"><svg class="icon icon-chevron-left" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true" focusable="false"><use href="#icon-chevron-left"/></svg></button>' +
          '<img class="hgLensBoxImg" alt="">' +
          '<button type="button" class="hgLensBoxNav hgLensBoxNext imageModalNav" aria-label="Next lens"><svg class="icon icon-chevron-right" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true" focusable="false"><use href="#icon-chevron-right"/></svg></button>' +
        '</div>' +
        '<figcaption class="hgLensBoxCap">' +
          '<p class="hgLensBoxCount" aria-live="polite"></p>' +
          '<h4 class="hgLensBoxTitle"><span></span> <span class="hgLensGuideVlt"></span></h4>' +
          '<p class="hgLensBoxDesc"></p>' +
        '</figcaption>' +
      '</figure>';
    document.body.appendChild(box);
    img = box.querySelector('.hgLensBoxImg');
    title = box.querySelector('.hgLensBoxTitle span');
    vlt = box.querySelector('.hgLensBoxTitle .hgLensGuideVlt');
    desc = box.querySelector('.hgLensBoxDesc');
    count = box.querySelector('.hgLensBoxCount');
    box.querySelector('.hgLensBoxClose').addEventListener('click', close);
    box.querySelector('.hgLensBoxPrev').addEventListener('click', function () { go(-1); });
    box.querySelector('.hgLensBoxNext').addEventListener('click', function () { go(1); });
    /* Click on the dimmed backdrop (the dialog itself, outside the figure) closes. */
    box.addEventListener('click', function (e) { if (e.target === box) close(); });
    box.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
    });
    box.addEventListener('close', function () {
      document.documentElement.style.overflow = '';
      if (lastFocus) lastFocus.focus();
    });
    var x0 = null;
    box.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    box.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      x0 = null;
      if (Math.abs(dx) > 50) go(dx < 0 ? 1 : -1);
    });
  }

  function render() {
    var b = list[idx];
    img.src = b.getAttribute('data-full');
    img.alt = b.getAttribute('data-name');
    title.textContent = b.getAttribute('data-name');
    vlt.textContent = b.getAttribute('data-vlt') || '';
    desc.textContent = b.getAttribute('data-desc') || '';
    count.textContent = (idx + 1) + ' / ' + list.length;
    box.classList.toggle('hgLensBox--single', list.length < 2);
    /* Warm the neighbours so paging feels instant. */
    [idx - 1, idx + 1].forEach(function (i) {
      var n = list[(i + list.length) % list.length];
      if (n) (new Image()).src = n.getAttribute('data-full');
    });
  }

  function go(d) { idx = (idx + d + list.length) % list.length; render(); }

  function open(btn) {
    if (!box) build();
    var guide = btn.closest('.hgLensGuide') || document;
    list = Array.prototype.slice.call(guide.querySelectorAll('.hgLensGuideZoom'));
    idx = Math.max(0, list.indexOf(btn));
    lastFocus = btn;
    render();
    document.documentElement.style.overflow = 'hidden';
    box.showModal();
  }

  function close() { if (box && box.open) box.close(); }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.hgLensGuideZoom');
    if (b) open(b);
  });
})();
